import React from 'react';

import {message} from 'antd';
import {observable, computed, action} from "mobx";
import http from 'libs/http';
import lodash from 'lodash'

// the hook
import {useTranslation} from 'react-i18next';

class Store {
  @observable records = [];
  @observable ids = [];
  @observable record = {};
  @observable quoteRecords = [];
  @observable handleRecord = {};
  @observable isFetching = false;
  @observable actionVisible = false;
  @observable numberVisible = false;
  @observable handleId = '';
  @observable addressId = ''
  @observable invoiceId = ''
  @observable poNum = ''
  @observable remark = ''
  @observable spp = {}
  @observable spq = {}
  @observable page = 1
  @observable quotePage = 1
  @observable pageSize = localStorage.getItem('purchasePageSize') || 10;
  @observable quotePageSize = localStorage.getItem('quotePageSize') || 10;
  @observable pageTotal = 10
  @observable quotePageTotal = 10


  //获取求购记录
  fetchRecords = (status) => {
    this.isFetching = true;
    this.records = [];
    let query = {...this.spp,status:status};
    http.post('/javaApi/front/inquiry/list',{ 
      pageNo: this.page,
      pageSize: this.pageSize,
      param: query 
    })
      .then(action('a', res => {
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.isFetching = false))
  };

  pageChange = (page, size, status) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    localStorage.setItem('purchasePageSize',size);
    this.fetchRecords(status)
}
  quotePageChange = (page, size) => {
    this.quoteRecords = []
    this.quotePage = page;
    this.quotePageSize = size;
    localStorage.setItem('quotePageSize',size);
    this.fetchQuoteRecords()
}

  // 求购记录：更新已读状态
  // updateReadStatus = (type) => {
  //   return http.patch('/api/front/inquiry/', {status: type})
  //     .then(res => {
  //       this.fetchRecords()
  //     })
  // }

  //获取报价单
  fetchQuoteRecords = () => {
    this.isFetching = true;
    let query = this.spq;
    http.post('/javaApi/front/quote/list',{ 
      pageNo: this.quotePage,
      pageSize: this.quotePageSize,
      param: query 
    })
      .then(action('a', res => {
        this.quoteRecords = res.data.result.data
        this.quotePageTotal = res.data.result.pageInfo.totalRows;
    }))
      .finally(action('b', () => this.isFetching = false))
  };

  //合并报价单
  mergeQuoteRecords = (ids) => {
    return http.post('/api/front/quote/', {ids: ids})
      .then(res => this.fetchQuoteRecords())
  }

  // 下单
  checkOrder = (data) => {
    return http.post('/javaApi/front/quote/quoteCreateOrder', data)
      .then(res => {
        this.orderId = res
        this.fetchQuoteRecords()
        message.success('下单成功！')
      })
  }

  // 整单关闭报价单
  closeOrder = (data) => {
    return http.post('/javaApi/front/quote/quoteClose', data)
      .then(res => {
        this.fetchQuoteRecords()
        message.success('关闭成功！')
      })
  }

    // 关闭报价单行
    closeOrderItem = (data) => {
      return http.post('/javaApi/front/quote/quoteItemClose', data)
        .then(res => {
          this.fetchQuoteRecords()
          message.success('关闭成功！')
        })
    }

  //下单
  showAction = (e, ids) => {
    e.stopPropagation();
    this.ids = lodash.flattenDeep([].concat(ids)).filter(v => v);
    this.record = this.quoteRecords?.length&&this.quoteRecords[0] || {};
    this.actionVisible = true
  }
  showNumber = (num) => {
    this.handleRecord = num;
    this.numberVisible = true;
}


}

export default new Store()
